module.exports = __webpack_public_path__ + "img/PUREHEALS3.77a08664.jpg";